const TYPES = {
    GET_HOME: 'GET_HOME',
    GET_HOME_COMPLETE: 'GET_HOME_COMPLETE',
    GET_HOME_FAILED: 'GET_HOME_FAILED'
};

export default {
    TYPES,

    getHome: payload => ({
        type: TYPES.GET_HOME,
        payload
    }),

    getHomeSuccess: home => ({
        type: TYPES.GET_HOME_COMPLETE,
        payload: {home}
    }),

    getHomeFailed: error => ({
        type: TYPES.GET_HOME_FAILED,
        payload: {error}
    })
};
